import type { LineItemRequestParams } from './models/line-item.model';
import type { UmgPromiseDateService } from './umg-promise-date.service';

export class LineItemPropertyService {
  constructor(private umgPromiseDateService: UmgPromiseDateService) {}

  buildProperties(params: LineItemRequestParams): any {
    const properties = {};
    this.processLivestreamProperties(params, properties);
    this.processPostConversionProperties(params, properties);
    this.processSellingPlanProperties(params, properties);
    this.processPerkProperties(params, properties);
    this.processReferralLinkProperties(params, properties);
    this.processUmgPromiseDateProperties(params, properties);
    this.processMarketingProperties(params, properties);
    return properties;
  }

  private processUmgPromiseDateProperties(params: LineItemRequestParams, properties: any): void {
    if (this.umgPromiseDateService.canProcess(params.attributes)) {
      const promiseDates = this.umgPromiseDateService.calculatePromiseDates(params.attributes);
      this.copyToProperties(promiseDates, properties);
    }
  }

  private copyToProperties(input: any, properties: any): void {
    Object.assign(properties, input);
  }

  private processPerkProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.perkMembershipVariantId) {
      properties[`__single_subscription_perk`] = params.perkMembershipVariantId;
    }
  }

  private processSellingPlanProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.sellingPlanId && !!params.product && !!params.term) {
      properties[`__selling_plan_id`] = params.sellingPlanId;
      const sellingPlan = params.product.selling_plan_groups
        .flatMap((group) => group.selling_plans)
        .find((plan) => params.sellingPlanId === plan.id);
      if (!!sellingPlan) {
        properties[`__selling_plan_name`] = sellingPlan.name;
      }
      const variant = params.product.variants.find((v) => v.id === params.id);
      if (!!variant) {
        properties[`__selling_plan_price`] = variant.price / 100;
      }
      properties[`__selling_plan_billing_interval_count`] = params.term.intervalCount;
      properties[`__selling_plan_billing_interval_type`] = params.term.intervalType;
    }
  }

  private processLivestreamProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.livestreamId) {
      properties[`__livestream_id__${params.livestreamId}`] = '';
    }
  }

  private processPostConversionProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.postId) {
      properties[`__post_id`] = params.postId;
    }
  }

  private processReferralLinkProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.referralLinkId && params.referralLinkId !== '') {
      properties[`__referral_link_id`] = params.referralLinkId;
    }
  }

  private processMarketingProperties(params: LineItemRequestParams, properties: any): void {
    if (!!params.optInToMarketingEmails) {
      properties[`__opt_in_to_marketing_emails`] = 'true';
    }
  }
}
